"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeviceScreenSize = void 0;

var _react = _interopRequireWildcard(require("react"));

var _mediaQueries = require("./mediaQueries");

var _lodash = _interopRequireDefault(require("lodash.throttle"));

var _utilities = require("@doordash/utilities");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DeviceTypeString;

(function (DeviceTypeString) {
  DeviceTypeString["widescreen"] = "widescreen";
  DeviceTypeString["desktop"] = "desktop";
  DeviceTypeString["tablet"] = "tablet";
  DeviceTypeString["mobile"] = "mobile";
})(DeviceTypeString || (DeviceTypeString = {}));

/**
 * SSR compatible(Isomorphic) Hook that checks the client device predicates based on the screen width using native browser API.
 * This can be also widely used in the Prism components where different props value depends on the device screen size.
 *
 * Motivation:
 * CSR components are using `MediaQuery` library which uses the `componentDidMount` to calculate the screen
 * size which runs asynchronously and might cause a jitter when doing DOM manipulation. This hook uses
 * `useLayoutEffect` which runs synchronously before browser paints and hence ideal for accessing the
 * eg, screen width, scroll width and perform the DOM mutation afterwards to avoid jitter effect.
 *
 * @return {DeviceScreenSizeType}
 */
var useDeviceScreenSize = function useDeviceScreenSize() {
  var breakPoints = _mediaQueries.Breakpoints;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      deviceScreenType = _useState2[0],
      setDeviceScreenType = _useState2[1];

  (0, _utilities.useIsomorphicLayoutEffect)(function () {
    var setScreenSize = function setScreenSize() {
      var windowWidth = window.innerWidth; // Here its not going to re-render on every time resize event handler is invoked.
      // It will re-render only it transitions to different device screen type as state
      // value gets updated.

      if (windowWidth < breakPoints.Tablet) setDeviceScreenType(DeviceTypeString.mobile);else if (windowWidth >= breakPoints.Tablet && windowWidth < breakPoints.Desktop) setDeviceScreenType(DeviceTypeString.tablet);else if (windowWidth >= breakPoints.Desktop && windowWidth < breakPoints.WideScreen) setDeviceScreenType(DeviceTypeString.desktop);else if (windowWidth >= breakPoints.WideScreen) setDeviceScreenType(DeviceTypeString.widescreen);
    }; // Run on initial render.


    setScreenSize();
    var throttledSetScreenSize = (0, _lodash["default"])(setScreenSize, 100);
    window.addEventListener('resize', throttledSetScreenSize);
    return function () {
      return window.removeEventListener('resize', throttledSetScreenSize);
    };
  }, []);

  var deviceScreenTypeDetector = _react["default"].useMemo(function () {
    var mediaQueries = {
      isMobile: deviceScreenType === DeviceTypeString.mobile,
      isTablet: deviceScreenType === DeviceTypeString.tablet,
      isDesktop: deviceScreenType === DeviceTypeString.desktop,
      isWideScreen: deviceScreenType === DeviceTypeString.widescreen
    };
    return _objectSpread(_objectSpread({}, mediaQueries), {}, {
      isMobileOrTablet: mediaQueries.isMobile || mediaQueries.isTablet,
      isTabletOrDesktop: mediaQueries.isTablet || mediaQueries.isDesktop,
      isTabletOrBigger: mediaQueries.isTablet || mediaQueries.isDesktop || mediaQueries.isWideScreen,
      isDesktopOrBigger: mediaQueries.isDesktop || mediaQueries.isWideScreen
    });
  }, [deviceScreenType]);

  return _objectSpread({
    deviceTypeString: deviceScreenType
  }, deviceScreenTypeDetector);
};

exports.useDeviceScreenSize = useDeviceScreenSize;